import { useEffect, useRef } from "react";

let ytReady;
const loadYT = () => {
  if (window.YT?.Player) return Promise.resolve(window.YT);
  if (!ytReady) {
    ytReady = new Promise((resolve) => {
      const prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => { prev?.(); resolve(window.YT); };
      const s = document.createElement("script");
      s.src = "https://www.youtube.com/iframe_api";
      document.body.appendChild(s);
    });
  }
  return ytReady;
};

// Counts only seconds actually played: jumps > 2.5s between polls (seeking ahead) are ignored.
export const YouTubeTracked = ({ videoId, onPercent, testId }) => {
  const host = useRef(null);
  const cb = useRef(onPercent);
  cb.current = onPercent;
  useEffect(() => {
    let player, timer, last = null, alive = true;
    const played = new Set();
    loadYT().then((YT) => {
      if (!alive) return;
      player = new YT.Player(host.current, { videoId, playerVars: { rel: 0, modestbranding: 1, playsinline: 1 }, width: "100%", height: "100%" });
      timer = setInterval(() => {
        if (!player?.getPlayerState) return;
        const t = player.getCurrentTime?.() || 0;
        const dur = Math.floor(player.getDuration?.() || 0);
        if (player.getPlayerState() === 1 && last != null && t > last && t - last <= 2.5) {
          for (let s = Math.floor(last); s < Math.floor(t); s += 1) played.add(s);
          if (player.getPlayerState() === 1 && dur && Math.floor(t) >= dur - 1) played.add(dur - 1);
        }
        last = t;
        if (dur) cb.current(Math.min(100, (played.size / dur) * 100));
      }, 1000);
    });
    return () => { alive = false; clearInterval(timer); player?.destroy?.(); };
  }, [videoId]);
  return (
    <div className="aspect-video w-full overflow-hidden rounded-lg bg-black" data-testid={testId}>
      <div ref={host} className="h-full w-full" />
    </div>
  );
};
